(function () {
  const zoomType = document.querySelector('product-info')?.dataset.zoom;
  if (zoomType !== 'custom_slider') return;

  let images = [];
  let currentIndex = 0;
  let touchStartX = 0;

  function buildLightbox() {
    if (document.getElementById('clb')) return;

    document.body.insertAdjacentHTML('beforeend', `
      <div id="clb" role="dialog" aria-modal="true" style="
        display:none; position:fixed; inset:0; z-index:99999;
        background:rgba(0,0,0,0.92); align-items:center; justify-content:center;
      ">
        <button id="clb-close" style="
          position:fixed; top:16px; right:20px;
          background:rgba(255,255,255,0.1); border:1px solid rgba(255,255,255,0.25);
          color:#fff; width:40px; height:40px; border-radius:50%;
          font-size:20px; cursor:pointer; line-height:1;
        ">✕</button>

        <button id="clb-prev" style="
          position:fixed; left:16px; top:50%; transform:translateY(-50%);
          background:rgba(255,255,255,0.1); border:1px solid rgba(255,255,255,0.25);
          color:#fff; width:48px; height:48px; border-radius:50%;
          font-size:22px; cursor:pointer;
        ">‹</button>

        <img id="clb-img" src="" alt="" style="
          max-width:88vw; max-height:82vh;
          object-fit:contain; border-radius:8px;
          transition: opacity 0.2s ease;
          user-select:none; pointer-events:none;
        "/>

        <button id="clb-next" style="
          position:fixed; right:16px; top:50%; transform:translateY(-50%);
          background:rgba(255,255,255,0.1); border:1px solid rgba(255,255,255,0.25);
          color:#fff; width:48px; height:48px; border-radius:50%;
          font-size:22px; cursor:pointer;
        ">›</button>

        <div id="clb-counter" style="
          position:fixed; bottom:20px; left:50%; transform:translateX(-50%);
          color:rgba(255,255,255,0.6); font-size:13px; font-family:sans-serif;
        ">1 / 1</div>
      </div>
    `);

    bindEvents();
  }

  function showImage(index) {
    if (index < 0 || index >= images.length) return;
    currentIndex = index;

    const img = document.getElementById('clb-img');
    img.style.opacity = '0';

    img.onload = () => { img.style.opacity = '1'; };
    img.src = images[currentIndex];

    document.getElementById('clb-counter').textContent = (currentIndex + 1) + ' / ' + images.length;

    document.getElementById('clb-prev').style.opacity = currentIndex === 0 ? '0.3' : '1';
    document.getElementById('clb-next').style.opacity = currentIndex === images.length - 1 ? '0.3' : '1';
  }

  function openLightbox(index) {
    buildLightbox();
    const lb = document.getElementById('clb');
    lb.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    showImage(index);
  }

  function closeLightbox() {
    const lb = document.getElementById('clb');
    if (lb) lb.style.display = 'none';
    document.body.style.overflow = '';
  }

  function bindEvents() {
    document.getElementById('clb-close').addEventListener('click', closeLightbox);

    document.getElementById('clb').addEventListener('click', function (e) {
      if (e.target === this) closeLightbox();
    });

    document.getElementById('clb-prev').addEventListener('click', function (e) {
      e.stopPropagation();
      showImage(currentIndex - 1);
    });

    document.getElementById('clb-next').addEventListener('click', function (e) {
      e.stopPropagation();
      showImage(currentIndex + 1);
    });

    document.addEventListener('keydown', function (e) {
      if (document.getElementById('clb').style.display === 'none') return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });

    const lb = document.getElementById('clb');
    lb.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    lb.addEventListener('touchend', function (e) {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? showImage(currentIndex + 1) : showImage(currentIndex - 1);
      }
    });
  }

  function attachGallery() {
    const gallery = document.querySelector('.product__media-gallery, [id^="MediaGallery"], .product-media-gallery');
    if (!gallery) return;

    function collectImages() {
      images = [];
      gallery.querySelectorAll('.product__media-item img').forEach(function (img) {
        const src = img.getAttribute('data-src') || img.currentSrc || img.src;
        const large = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024)(\.\w+)$/, '_2048x2048$2');
        if (large && !large.includes('no-image')) images.push(large);
      });
    }

    function attachClicks() {
      collectImages();
      gallery.querySelectorAll('.product__media-item').forEach(function (item, i) {
        if (item.dataset.lbReady) return;
        item.dataset.lbReady = '1';
        item.style.cursor = 'zoom-in';
        
        item.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          collectImages();
          openLightbox(i);
        }, true);
      });
    }

    attachClicks();

    new MutationObserver(attachClicks).observe(gallery, {
      childList: true, subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachGallery);
  } else {
    attachGallery();
  }

  document.addEventListener('shopify:section:load', attachGallery);

})();